'use client';

import { usePathname } from 'next/navigation';
import { useEffect } from 'react';

declare global {
	interface Window {
		HelpGuidesChat?: HelpGuidesChat;
		HelpGuidesChatSettings?: {
			app_id: string;
			hide_default_launcher: boolean;
		};
	}
}

interface HelpGuidesChat {
	(...args: unknown[]): void;
	q?: unknown[];
}

const HELPGUIDES_APP_ID = '4025e8c9-71ea-4557-850d-662c78598919';
const HELPGUIDES_SCRIPT_SRC = 'https://trydocent.ai/chat/messenger.js';

interface HelpGuidesChatBotProps {
	enabled?: boolean;
	whiteListedPages: string[];
}

export const HelpGuidesChatBot = ({ enabled = true, whiteListedPages }: HelpGuidesChatBotProps) => {
	const scriptId = 'help-guides-chat';
	const pathname = usePathname();

	useEffect(() => {
		const isWhitelisted = pathname && whiteListedPages.some((page) => pathname.startsWith(page));

		if (!enabled || !isWhitelisted) {
			window.HelpGuidesChat?.('hide');
			return;
		}

		if (!window.HelpGuidesChatSettings) {
			window.HelpGuidesChatSettings = {
				app_id: HELPGUIDES_APP_ID,
				hide_default_launcher: true
			};
		}

		if (!document.getElementById(scriptId)) {
			const chat: HelpGuidesChat = (...args: unknown[]) => {
				chat.q = chat.q || [];
				chat.q.push(args);
			};

			window.HelpGuidesChat = chat;

			const script = document.createElement('script');
			script.id = scriptId;
			script.async = true;
			script.src = HELPGUIDES_SCRIPT_SRC;
			document.head.appendChild(script);
			chat('boot', window.HelpGuidesChatSettings);
		}
	}, [enabled, pathname, whiteListedPages]);

	return null;
};
